/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';

function AddNewCrewCollaboratorModalController(this: JS5Object, DynamicPropertiesService: JS5Object, UtilsService: JS5Object) {
    this.disableOKButton = () => {
        return this.newCollabEditForm.$pristine ||
            !_.get(this, 'newCrewCollab.collaborator.displayName') ||
            !_.get(this, 'newCrewCollab.collaborator.sortName') ||
            !_.get(this, 'newCrewCollab.selectedRoles') ||
            (!_.get(this, 'newCrewCollab.collaborator.character') && !_.get(this, 'actorIsSelf') && this.resolve.newActor) ||
            (_.get(this, 'newCrewCollab.selectedRoles') && !_.size(_.get(this, 'newCrewCollab.selectedRoles')));
    };

    this.$onInit = () => {
        this.newCrewCollab = {};
        this.actorIsSelf = false;

        if (this.resolve.newActor) {
            this.newCrewCollab.selectedRoles = ['Actor'];
        } else {
            DynamicPropertiesService.queryForProperties().then(() => {
                this.availableRoles = DynamicPropertiesService.getPropValueAsList('package.crewMemberRoles');
            });
        }
    };
    this.handleDisplayNameChange = () => {
        _.set(this, 'newCrewCollab.collaborator.sortName', _.cloneDeep(UtilsService.transformDisplayNameToSortName(_.get(this, 'newCrewCollab.collaborator.displayName'))));
    };
}

angular.module('prism-ui.package').component('addNewCrewCollaboratorModal', {
    templateUrl: 'package/editor/components/modals/collaborators/addNewCrewCollaboratorModal/add-new-crew-collaborator-modal-template.html',
    controller: AddNewCrewCollaboratorModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});
